"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyTableHead = exports.StickyTableCellRight = exports.StickyTableCell = exports.StickyTableCellLeft = void 0;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const react_1 = require("@emotion/react");
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const mui_1 = require("tss-react/mui");
const stickyCellStyles = {
    position: 'sticky',
    zIndex: '2',
};
exports.StickyTableCellLeft = (0, mui_1.withStyles)(TableCell_1.default, () => ({
    head: Object.assign(Object.assign({}, stickyCellStyles), { left: 0, zIndex: 3 }),
    body: Object.assign(Object.assign({}, stickyCellStyles), { left: 0, padding: '8px' }),
}));
exports.StickyTableCell = (0, mui_1.withStyles)(TableCell_1.default, () => ({
    head: Object.assign(Object.assign({}, stickyCellStyles), { left: 0, zIndex: 3 }),
    body: Object.assign(Object.assign({}, stickyCellStyles), { left: 0, padding: '8px' }),
}));
exports.StickyTableCellRight = (0, mui_1.withStyles)(TableCell_1.default, () => ({
    head: Object.assign(Object.assign({}, stickyCellStyles), { right: 0, zIndex: 3, padding: '8px' }),
    body: Object.assign(Object.assign({}, stickyCellStyles), { right: 0, padding: '8px' }),
}));
const stickyHeadStyles = {
    left: 0,
    position: 'sticky',
    zIndex: '3',
    padding: '8px',
};
exports.StickyTableHead = (0, mui_1.withStyles)(TableCell_1.default, () => ({
    head: stickyHeadStyles,
    body: stickyHeadStyles,
}));
const filterOverlayEffect = (0, react_1.keyframes) `
  0% {
    z-index: 1;
  }
  100% {
    z-index: 0;
  }
`;
const styles = ({ palette, shadows, spacing }) => ({
    chartContainer: {
        width: '100%',
        margin: 'auto',
        height: 'auto',
        minHeight: 225,
        paddingTop: 40,
        position: 'relative',
    },
    clickableText: {
        color: palette.primary.main,
        cursor: 'pointer',
        '&:hover': {
            color: palette.primary.light,
        },
        position: 'relative',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    graphIcons: {
        height: '100%',
    },
    graphIconsWithOpacity: {
        height: '100%',
        opacity: '0.7',
    },
    headerContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        margin: 'auto',
        padding: '30px',
    },
    moreSettings: {
        display: 'flex',
        alignItems: 'center',
    },
    moreSettingsSpacer: {
        width: 8,
    },
    registerContainer: {
        height: 'calc(100vh - 200px)',
        width: '100%',
    },
    root: {
        marginBottom: 30,
    },
    selectContainer: {
        boxShadow: shadows[2],
    },
    bottomSpacer: {
        height: spacing(3),
    },
    clearButton: {
        marginBottom: spacing(2),
        backgroundColor: palette.action.surface,
        color: `${palette.primary.contrastText} !important`,
        '&:hover': {
            backgroundColor: palette.secondary.dark,
        },
    },
    filterOverlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 9,
        animation: `${filterOverlayEffect} 0s 1s forwards`,
    },
});
exports.default = styles;
